import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import 'bootstrap-select-dropdown'
import '../../../shared/js/components/cloning'

//Define selector
const selector = '.multiselect'

class MultiselectComponent {
    
    /**
     * Construct component
     * @param elements
    */
    constructor(elements) {
        
        /**
         * Multiselect elements jQuery object
         * @type {object}
        */
        this.elements = elements
        
        this.bindEvents()
        
    }
    
    /**
     * Setup elements
    */
    setupElements() {
        this.elements.each((i, elem) => {
            this.setupElement(jQuery(elem))
        })
    }
    
    /**
     * Setup element
     * @param element
    */
    setupElement(element) {
        
        const
            placeholder = element.data('placeholder'),
            multiple = element.attr('multiple')
        
        element.selectDropdown({
            badges: false,
            classBtnSelect: 'custom-select',
            maxListLength: 1,
            search: false,
            showSelected: false,
            textNoneSelected: (placeholder ? placeholder : 'Select'),
            textMultipleSelected: ((placeholder ? (placeholder + ': ') : '') + '%count_selected% selected')
        })
        
    }
    
    /**
     * Handle cloned
     * @param event
    */
    handleClone(event) {
        jQuery(event.target).find(selector).each((i, elem) => {
            this.setupElement(jQuery(elem))
        })
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Cloned event
        jQuery(document).on('cloned', '.has-multiselects', this.handleClone.bind(this))
        
        //Cancel if no elements
        if (this.elements.length === 0) {
            return
        }
        
        //Bind run modules event
        EventBus.subscribe('run-modules', this.setupElements.bind(this))
        
        //Bind form reset
        jQuery(document).on('reset', 'form', (event) => {
            jQuery(event.target).find(selector).each((i, select) => {
                jQuery(select).selectDropdown('deselectAll')
            })
        })
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    const elements = jQuery(selector)
    new MultiselectComponent(elements)
})

export default MultiselectComponent